// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Home-root-_ZJme {
    padding-left: 0px;
    padding-right: 0px;
    overflow-x: hidden;
    /* background: linear-gradient(180deg, var(--primary-color) 50%, #ffffff 100%); */
}

.Home-container-D2D0w {
    width: 95%;
    margin: 0 auto;
    /* max-width: 1274px; */
}

.Home-homePageContainer-uMyvk {
    padding-top: 0px;
    padding-bottom: 20px;
}

.Home-displayGrid-isUcU {
    display: grid;
    grid-template-columns: 24% 24% 24% 24%;
    grid-gap: 17px;
    margin: 0px 6px;
}

.Home-popularGridWidth-AN5mo {
    width: 95%;
    /* max-width: 1172px; */
    margin: 40px auto 40px;
    /*  background-color: var(--primary-gray-bg); */
    /* padding: 41px 58px; */
    border-radius: 20px;
    /* box-shadow: 0px 2px 18px var(--primary-box-shadow); */
    position: relative;
    z-index: 1;
}

.Home-layout2Bottom-W23sE {
    padding-bottom: 80px;
}

.Home-feedbackSpacingContainer-W9hyl {
    padding-bottom: 70px;
}

.Home-skeletonContainerPadding-dJZiW {
    padding: 0px 15px;
}

.Home-sliderHeadingFlex-d6Mr5 {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    gap: 10px;
    -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    -webkit-box-pack: justify;
        -ms-flex-pack: justify;
            justify-content: space-between;
    margin: 35px 15px 35px;
    font-family: var(--font-family-base) !important;
}

.Home-sectionTitle-B8fJb {
    color: var(--secondary-oscuro);
    font-size: 32px;
    font-family: var(--font-family-base);
    font-weight: bold;
    line-height: normal;
    padding: 0px 15px 0 6px;
    margin: 0;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    gap: 10px;
}

.Home-sectionTitleIcon-q8qFZ {
    width: 120px;
    height: auto;
    -webkit-transform: translateY(20px);
        -ms-transform: translateY(20px);
            transform: translateY(20px);
}

.Home-sectionTitleQuedateIcon-i4keJ {
    -webkit-transform: translateY(10px);
        -ms-transform: translateY(10px);
            transform: translateY(10px);
}

.Home-hostCtaSection-RIIMY {
    background: var(--secondary-cielo);
    border-radius: 28px;
    margin: 40px auto 70px auto;
    width: 95%;
    color: var(--secondary-oscuro);
}

.Home-hostCtaGrid-o2HY1 {
    display: grid;
    grid-template-columns: 2fr 0.5fr 2.5fr 1fr;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    gap: 24px;
    padding: 5px 40px 20px 40px;
}

.Home-hostCtaTitle-Cq6L2 {
    color: var(--secondary-oscuro);
    font-family: var(--font-family-base);
    font-size: 32px;
    font-weight: bold;
    line-height: normal;
    margin: 0 0 12px 0;
}

.Home-hostCtaSubtitle-AmbSy {
    color: var(--secondary-oscuro);
    font-family: var(--font-family-base);
    font-weight: bold;
    font-size: 24px;
    margin: 0;
}

.Home-hostCtaImageWrap-J3_w6 {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
}

.Home-hostCtaImage-IXF9_ {
    width: 197px;
    height: 197px;
}

.Home-hostCtaBtnWrap-kbiBF {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
}

.Home-hostCtaBtn-RNb7o {
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
    gap: 8px;
    background: var(--secondary-oscuro);
    color: #ffffff;
    border-radius: 30px;
    padding: 14px 24px;
    font-family: var(--font-family-base);
    font-size: 32px;
    font-weight: bold;
    text-align: center;
    text-decoration: none !important;
    cursor: pointer;
}

.Home-hostCtaBtnIcon-qaS1J {
    width: 25px;
    height: 25px;
}

.Home-highlight-EakF3 {
    color: var(--primary-color);
}

@media screen and (max-width: 992px) {
    .Home-hostCtaGrid-o2HY1 {
        grid-template-columns: 1fr 1fr;
        gap: 30px;
        padding: 40px 30px;
    }
}

@media screen and (max-width: 1200px) {
    .Home-layout2Bottom-W23sE {
        padding: 0 15px 80px;
    }
}

@media screen and (max-width: 767px) {
    .Home-displayGrid-isUcU {
        grid-template-columns: 100%;
    }

    .Home-hostCtaSection-RIIMY {
        margin: 20px auto;
    }

    .Home-hostCtaGrid-o2HY1 {
        grid-template-columns: 1fr;
        padding: 30px 20px;
        text-align: center;
    }

    .Home-hostCtaTitle-Cq6L2 {
        font-size: 26px;
    }

    .Home-hostCtaImage-IXF9_ {
        max-width: 110px;
    }

    .Home-popularGridWidth-AN5mo {
        padding: 30px 15px 20px;
    }

    .Home-sectionTitle-B8fJb {
        font-size: 22px;
    }

    .Home-sectionTitleIcon-q8qFZ {
        width: 50px;
        height: 50px;
    }

    .Home-feedbackSpacingContainer-W9hyl {
        padding-bottom: 0;
        margin-bottom: 80px;
    }
}`, "",{"version":3,"sources":["webpack://./src/routes/home/Home.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,iFAAiF;AACrF;;AAEA;IACI,UAAU;IACV,cAAc;IACd,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,sCAAsC;IACtC,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,uBAAuB;IACvB,sBAAsB;IACtB,+CAA+C;IAC/C,wBAAwB;IACxB,mBAAmB;IACnB,wDAAwD;IACxD,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,SAAS;IACT,mBAAe;QAAf,eAAe;IACf,yBAA8B;QAA9B,sBAA8B;YAA9B,8BAA8B;IAC9B,sBAAsB;IACtB,+CAA+C;AACnD;;AAEA;IACI,8BAA8B;IAC9B,eAAe;IACf,oCAAoC;IACpC,iBAAiB;IACjB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,mCAA2B;QAA3B,+BAA2B;YAA3B,2BAA2B;AAC/B;;AAEA;IACI,mCAA2B;QAA3B,+BAA2B;YAA3B,2BAA2B;AAC/B;;AAEA;IACI,kCAAkC;IAClC,mBAAmB;IACnB,2BAA2B;IAC3B,UAAU;IACV,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,0CAA0C;IAC1C,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,SAAS;IACT,2BAA2B;AAC/B;;AAEA;IACI,8BAA8B;IAC9B,oCAAoC;IACpC,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;IAC9B,oCAAoC;IACpC,iBAAiB;IACjB,eAAe;IACf,SAAS;AACb;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;AACvB;;AAEA;IACI,2BAAoB;IAApB,2BAAoB;IAApB,oBAAoB;IACpB,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,QAAQ;IACR,mCAAmC;IACnC,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,oCAAoC;IACpC,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,2BAA2B;AAC/B;;AAGA;IACI;QACI,8BAA8B;QAC9B,SAAS;QACT,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,oBAAoB;IACxB;AACJ;;AAEA;IACI;QACI,2BAA2B;IAC/B;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,0BAA0B;QAC1B,kBAAkB;QAClB,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;IACvB;AACJ","sourcesContent":[".root {\n    padding-left: 0px;\n    padding-right: 0px;\n    overflow-x: hidden;\n    /* background: linear-gradient(180deg, var(--primary-color) 50%, #ffffff 100%); */\n}\n\n.container {\n    width: 95%;\n    margin: 0 auto;\n    /* max-width: 1274px; */\n}\n\n.homePageContainer {\n    padding-top: 0px;\n    padding-bottom: 20px;\n}\n\n.displayGrid {\n    display: grid;\n    grid-template-columns: 24% 24% 24% 24%;\n    grid-gap: 17px;\n    margin: 0px 6px;\n}\n\n.popularGridWidth {\n    width: 95%;\n    /* max-width: 1172px; */\n    margin: 40px auto 40px;\n    /*  background-color: var(--primary-gray-bg); */\n    /* padding: 41px 58px; */\n    border-radius: 20px;\n    /* box-shadow: 0px 2px 18px var(--primary-box-shadow); */\n    position: relative;\n    z-index: 1;\n}\n\n.layout2Bottom {\n    padding-bottom: 80px;\n}\n\n.feedbackSpacingContainer {\n    padding-bottom: 70px;\n}\n\n.skeletonContainerPadding {\n    padding: 0px 15px;\n}\n\n.sliderHeadingFlex {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    margin: 35px 15px 35px;\n    font-family: var(--font-family-base) !important;\n}\n\n.sectionTitle {\n    color: var(--secondary-oscuro);\n    font-size: 32px;\n    font-family: var(--font-family-base);\n    font-weight: bold;\n    line-height: normal;\n    padding: 0px 15px 0 6px;\n    margin: 0;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.sectionTitleIcon {\n    width: 120px;\n    height: auto;\n    transform: translateY(20px);\n}\n\n.sectionTitleQuedateIcon {\n    transform: translateY(10px);\n}\n\n.hostCtaSection {\n    background: var(--secondary-cielo);\n    border-radius: 28px;\n    margin: 40px auto 70px auto;\n    width: 95%;\n    color: var(--secondary-oscuro);\n}\n\n.hostCtaGrid {\n    display: grid;\n    grid-template-columns: 2fr 0.5fr 2.5fr 1fr;\n    align-items: center;\n    gap: 24px;\n    padding: 5px 40px 20px 40px;\n}\n\n.hostCtaTitle {\n    color: var(--secondary-oscuro);\n    font-family: var(--font-family-base);\n    font-size: 32px;\n    font-weight: bold;\n    line-height: normal;\n    margin: 0 0 12px 0;\n}\n\n.hostCtaSubtitle {\n    color: var(--secondary-oscuro);\n    font-family: var(--font-family-base);\n    font-weight: bold;\n    font-size: 24px;\n    margin: 0;\n}\n\n.hostCtaImageWrap {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.hostCtaImage {\n    width: 197px;\n    height: 197px;\n}\n\n.hostCtaBtnWrap {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.hostCtaBtn {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    background: var(--secondary-oscuro);\n    color: #ffffff;\n    border-radius: 30px;\n    padding: 14px 24px;\n    font-family: var(--font-family-base);\n    font-size: 32px;\n    font-weight: bold;\n    text-align: center;\n    text-decoration: none !important;\n    cursor: pointer;\n}\n\n.hostCtaBtnIcon {\n    width: 25px;\n    height: 25px;\n}\n\n.highlight {\n    color: var(--primary-color);\n}\n\n\n@media screen and (max-width: 992px) {\n    .hostCtaGrid {\n        grid-template-columns: 1fr 1fr;\n        gap: 30px;\n        padding: 40px 30px;\n    }\n}\n\n@media screen and (max-width: 1200px) {\n    .layout2Bottom {\n        padding: 0 15px 80px;\n    }\n}\n\n@media screen and (max-width: 767px) {\n    .displayGrid {\n        grid-template-columns: 100%;\n    }\n\n    .hostCtaSection {\n        margin: 20px auto;\n    }\n\n    .hostCtaGrid {\n        grid-template-columns: 1fr;\n        padding: 30px 20px;\n        text-align: center;\n    }\n\n    .hostCtaTitle {\n        font-size: 26px;\n    }\n\n    .hostCtaImage {\n        max-width: 110px;\n    }\n\n    .popularGridWidth {\n        padding: 30px 15px 20px;\n    }\n\n    .sectionTitle {\n        font-size: 22px;\n    }\n\n    .sectionTitleIcon {\n        width: 50px;\n        height: 50px;\n    }\n\n    .feedbackSpacingContainer {\n        padding-bottom: 0;\n        margin-bottom: 80px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Home-root-_ZJme`,
	"container": `Home-container-D2D0w`,
	"homePageContainer": `Home-homePageContainer-uMyvk`,
	"displayGrid": `Home-displayGrid-isUcU`,
	"popularGridWidth": `Home-popularGridWidth-AN5mo`,
	"layout2Bottom": `Home-layout2Bottom-W23sE`,
	"feedbackSpacingContainer": `Home-feedbackSpacingContainer-W9hyl`,
	"skeletonContainerPadding": `Home-skeletonContainerPadding-dJZiW`,
	"sliderHeadingFlex": `Home-sliderHeadingFlex-d6Mr5`,
	"sectionTitle": `Home-sectionTitle-B8fJb`,
	"sectionTitleIcon": `Home-sectionTitleIcon-q8qFZ`,
	"sectionTitleQuedateIcon": `Home-sectionTitleQuedateIcon-i4keJ`,
	"hostCtaSection": `Home-hostCtaSection-RIIMY`,
	"hostCtaGrid": `Home-hostCtaGrid-o2HY1`,
	"hostCtaTitle": `Home-hostCtaTitle-Cq6L2`,
	"hostCtaSubtitle": `Home-hostCtaSubtitle-AmbSy`,
	"hostCtaImageWrap": `Home-hostCtaImageWrap-J3_w6`,
	"hostCtaImage": `Home-hostCtaImage-IXF9_`,
	"hostCtaBtnWrap": `Home-hostCtaBtnWrap-kbiBF`,
	"hostCtaBtn": `Home-hostCtaBtn-RNb7o`,
	"hostCtaBtnIcon": `Home-hostCtaBtnIcon-qaS1J`,
	"highlight": `Home-highlight-EakF3`
};
module.exports = ___CSS_LOADER_EXPORT___;
